/**
 * @generated SignedSource<<2ba1fe58960884b501da3bab54e5b369>>
 * @relayHash e4f905af06ac0f2931b3d1537d1fc617
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 82be96e5ec49e837f88198eea7549d67dc78391ab549d2a233b0d294ec155469

import type { ConcreteRequest } from 'relay-runtime';
export type useCreateKbServerAppLinkIdQueryJsmCardQuery$variables = {
  cloudId: string;
  projectIdentifier: string;
};
export type useCreateKbServerAppLinkIdQueryJsmCardQuery$data = {
  readonly knowledgeBase_confluenceAppLinkDetails: {
    readonly __typename: "KnowledgeBaseConfluenceAppLinkDetails";
    readonly appLinkId: string | null;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
};
export type useCreateKbServerAppLinkIdQueryJsmCardQuery = {
  response: useCreateKbServerAppLinkIdQueryJsmCardQuery$data;
  variables: useCreateKbServerAppLinkIdQueryJsmCardQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectIdentifier"
},
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "projectIdentifier",
        "variableName": "projectIdentifier"
      }
    ],
    "kind": "LinkedField",
    "name": "knowledgeBase_confluenceAppLinkDetails",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "__typename"
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "kind": "ScalarField",
            "name": "appLinkId"
          }
        ],
        "type": "KnowledgeBaseConfluenceAppLinkDetails"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useCreateKbServerAppLinkIdQueryJsmCardQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useCreateKbServerAppLinkIdQueryJsmCardQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "id": "82be96e5ec49e837f88198eea7549d67dc78391ab549d2a233b0d294ec155469",
    "metadata": {},
    "name": "useCreateKbServerAppLinkIdQueryJsmCardQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "46a8de515facf5e24f77ae76bdac4c07";

export default node;
